import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    background: ['shop now - image'],
    button: ['shop now - button'],
    sub_button: ['close - button']
  }
};

const RadiusFullCountdownTracking: FC = () => {
  const tracking = useSelector((state: any) => state.trackings.tracking);

  const style = `
  .root_tracking {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    
    .backgroundImage {
      background: rgba(0, 0, 0, 0.8);
      width: 100%;
      height: 100%;

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .close_btn {
      height: 1.5rem;
      position: absolute;
      top: 6%;
      right: 0;

      display: flex;
      align-items: center;
    }

    .center {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      flex-direction: column;
      gap: 3rem;
    }
    .top {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .top_center {
      width: 80%;
    }
    .top .sub_title {
      height: 1.5rem;
    }
    .top .title {
      height: 3rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .circle_wrapper {
      width: 100%;
      height: 25rem;
      position: relative;
      text-align: center;
    }
    .circleImage  {
      width: 25rem;
      height: 25rem;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      border-radius: 25rem;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
    .modal_wrapper {
      color: #000;
      font-size: 0.78513rem;
      font-weight: 400;
      font-family: Roboto;
    }

    .countdown_grid {
      display: grid;
      grid-template-columns: 3.5rem 0.5rem 3.5rem 0.5rem 3.5rem;
      justify-content: space-between;
      gap: 0.5rem;
    }
    .countdown_grid li {
      text-align: center;
    }

    .bottom {
      width: 100%;
    }
    .bottom ul {
      height: 2.5rem;
      padding: 0 10%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .bottom_btn {
      width: 100%;
      height: 4.5rem;
      border: 0;

      position: absolute;
      bottom: 0;
    }

    .tracking_center {
      display: flex;
      align-items: center;
      justify-content: end;
    }
  }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="close_btn tracking_center">
          <EditTracking value={tracking?.sub_button?.[0]} type="sub_button" />
        </div>

        <div className="center">
          <div className="top">
            <div className="top_center">
              <div className="sub_title" />
              <div className="title" />
            </div>
          </div>

          {/* <div className="circleImageRelative" /> */}
          <div className="circle_wrapper tracking_center">
            {/* <div className="circleImage tracking_center"> */}
            <EditTracking value={tracking?.background?.[0]} type="background" />
            {/* </div> */}
          </div>

          <div className="bottom" />
        </div>

        <div className="bottom_btn tracking_center">
          <EditTracking value={tracking?.button?.[0]} type="button" />
        </div>
      </div>
    </>
  );
};
export default RadiusFullCountdownTracking;
